
















































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import swal from 'sweetalert2'
import OnBoarding from '../../apiClient/OnBoarding'
import Eforms from '../../apiClient/Eforms'
import Folders from '../../apiClient/Folders'
import _ from 'underscore'
import Alert from '@/components/generics/Alert.vue'
import VueElementLoading from 'vue-element-loading'
import vueDropzone from 'vue2-dropzone'
import BillboardPreview from '../billboard/billboard-preview/BillboardPreview.vue'

@Component({
  components: {
    Alert,
    VueElementLoading,
    vueDropzone,
    BillboardPreview
  }
})
export default class CreateOnBoarding extends Vue {
  actions = []
  menu = []
  ob: OnBoarding
  id: any
  eformService: Eforms
  foldersService: Folders
  config: {}
  obname: string
  alldata: boolean
  allimage: boolean
  allmandatory: boolean
  message: string
  show: boolean
  templateId: number
  institutionalImage: any
  eforms: any
  msjBienvenida: any
  form: any
  title: string
  errorEforms: boolean
  bloq4: boolean
  btnSave: boolean
  foldersAvailable: Array<any>
  selectedDestinationFolder: any
  $refs: {
    file: HTMLElement
    dropzone: HTMLElement
    alert: HTMLElement
    defaultFocus: HTMLInputElement
  }
  data() {
    return {
      config: [],
      obname: '',
      institutionalImage: '',
      subjectlength: 0,
      alldata: true,
      allimage: true,
      allmandatory: true,
      message: '',
      show: false,
      id: 0,
      eforms: {
        id: '',
        data: [],
        templateId: '',
        asunto: '',
        descripcion: '',
        templateList: []
      },
      msjBienvenida: {
        data: [],
        maxCount: 140,
        remainingCount: 140,
        id: 0,
        urlLink: '',
        urlVideo: '',
        combo: ''
      },
      form: {
        details: {
          video: ''
        }
      },
      dropOptions: {
        url: 'http://localhost',
        autoProcessQueue: false,
        maxFiles: 1,
        maxFilesize: 5,
        addRemoveLinks: true,
        acceptedFiles: 'image/png,image/jpeg',
        dictDefaultMessage:
          "<div><span class='cloud'></span></div>" +
          this.$t('message.ob_move_select_file')
      },
      errorEforms: false,
      bloq4: false,
      file: '',
      btnSave: false,
      foldersAvailable: [],
      selectedDestinationFolder: {
        carpeta_id: ''
      },
      perceptionSwitch: true
    }
  }
  created() {
    this.show = false
    this.ob = new OnBoarding()
    this.eformService = new Eforms()
    this.foldersService = new Folders()
    this.id = this.$route.params.id
    this.getFoldersAvailable()
    this.getOB()
    this.welcomeMsj()

  }
  mounted() {
    this.setFocus()
  }
  setFocus() {
    this.$refs.defaultFocus.focus()
  }
  async getFoldersAvailable() {
    try {
      const {
        data: {
          results: { data }
        }
      } = await this.foldersService.getFoldersAvailable({})

      const that = this
      this.foldersAvailable = data.reduce(function (acc, folder) {
        if (
          (folder.visible == 'f' || folder.visible == 't') &&
          folder.bloqueante == '' &&
          folder.efimero == 'f'
        ) {
          const altText =
            folder.visible == 't'
              ? that.$t('message.ob_destination_folder_visible')
              : that.$t('message.ob_destination_folder_notvisible')
          folder.carpeta_nombre = folder.carpeta_nombre + ' - ' + altText
          acc.push(folder)
        }
        return acc
      }, [])
    } catch ({
      data: {
        results: { data }
      }
    }) {}
  }
  getPerceptionField() {
    const datosPersonales = this.$store.getters.getDatosPersonalesSection
    if (!datosPersonales || !datosPersonales.levels) return null
    
    for (const level of datosPersonales.levels) {
      if (level.fields) {
        const field = level.fields.find((f: any) => f.name === 'perception')
        if (field) return field
      }
    }
    return null
  }
  onPerceptionChange() {
    this.validate()
  }
  async getOB() {
    let that = this
    await this.getEform()
    if (Number(this.id) > 0) {
      await this.ob
        .getConfigById(this.id)
        .then(async (result: any) => {
          let res = result.status === 200 ? result.data : []

          this.obname = res[0].nombre
          this.config = res[0].template
          // VUEX
          this.$store.dispatch('setSections', { sections: this.config })
          // VUEX
          this.msjBienvenida.data = res[0].bienvenida
          this.msjBienvenida.id = res[0].bienvenida.id_tipo_msg_bienvenida
          if (this.msjBienvenida.id == 1) {
            this.msjBienvenida.urlLink = res[0].bienvenida.url
          }
          if (this.msjBienvenida.id == 2) {
            this.msjBienvenida.urlVideo = res[0].bienvenida.url
          }
          /* _.each(this.config,(section) => { */
          _.each(
            this.$store.getters.getSections.sections[1].levels,
            (level: any) => {
              _.each(level.fields, (field: any) => {
                if (!field.use) {
                  that.alldata = false
                }
                if (!field.use_image) {
                  that.allimage = false
                }
                if (!field.mandatory) {
                  that.allmandatory = false
                }
              })
            }
          )

          this.selectedDestinationFolder.carpeta_id =
            res[0].id_categoria_tipo_empresa
          this.eforms.id = this.$store.getters.getSections.sections[3].idPackage
          if (this.eforms.id) {
            this.showInfoEforms('loaded')
          }
          that.show = true
          this.validate()
          this.countdown()
        })
        /* }) */
        .catch((result: any) => {})
    } else {
      this.ob
        .getBaseConfig()
        .then((result: any) => {
          let res = result.status === 200 ? result.data : []
          this.config = res
          // VUEX
          this.$store.dispatch('setSections', { sections: this.config })
          // VUEX
          /* _.each(this.config,(section) => { */
          _.each(
            this.$store.getters.getSections.sections[1].levels,
            (level: any) => {
              _.each(level.fields, (field: any) => {
                if (!field.use) {
                  that.alldata = false
                }
                if (!field.use_image) {
                  that.allimage = false
                }
                if (!field.mandatory) {
                  that.allmandatory = false
                }
              })
            }
          )
          /* }); */
          that.show = true
          this.validate()
          this.countdown()
        })
        .catch((result: any) => {})
    }
  }
  async getEform() {
    await this.eformService
      .getEformTemplates()
      .then((res) => {
        this.eforms.data = res.data.results.data
      })
      .catch((error) => {
        this.errorEforms = true
      })
  }

  showInfoEforms(tmp) {
    var tmp: any
    if (tmp == 'loaded') {
      this.eforms.data.forEach((element) => {
        if (this.eforms.id != '') {
          if (this.eforms.id == element.id) {
            tmp = JSON.parse(element.metadata)
            this.eforms.asunto = tmp.asunto
            if (tmp.descripcion) {
              this.eforms.descripcion = atob(tmp.descripcion)
            } else {
              this.eforms.descripcion = tmp.mensaje
            }
            this.eforms.templateList = element.templates
          }
        }
      })
    } else {
      /* _.each(this.config,(section) => { */
      this.$store.getters.getSections.sections[3].idPackage = tmp
      /* }); */
      this.getInfoEforms(tmp)
    }
    this.validate()
  }
  getInfoEforms(id) {
    var tmp: any
    if (id) {
      this.eforms.asunto = ''
      this.eforms.descripcion = ''
      this.eforms.templateList = ''
      this.eforms.data.forEach((element) => {
        if (id == element.id) {
          tmp = JSON.parse(element.metadata)
          this.eforms.asunto = tmp.asunto
          if (tmp.descripcion) {
            this.eforms.descripcion = atob(tmp.descripcion)
          } else {
            this.eforms.descripcion = tmp.mensaje
          }
          this.eforms.templateList = element.templates
        }
      })
    }
  }
  titleEach(item) {
    var str = ''
    item.forEach((element) => {
      str += element.alias + ' , '
    })
    var lenght = str.length
    var res = str.substr(0, lenght - 2).trim()
    //res +=".";
    return res
  }
  validate() {
    var title: boolean
    var infoPersonal: boolean
    var docPersonales: boolean
    var eForms: boolean
    var institucional: boolean
    var video: boolean

    //Secciones
    var titleOnboarding = []
    var section1 = []
    var section2 = []
    var section3 = []
    var section4 = []
    var section5 = []

    this.obname !== ''
      ? titleOnboarding.push(true)
      : titleOnboarding.push(false)

    _.each(this.$store.getters.getSections.sections[0].levels, (level: any) => {
      section1.push(level.use)
    })
    _.each(this.$store.getters.getSections.sections[1].levels, (level: any) => {
      _.each(level.fields, (field: any) => {
        section2.push(field.use)
      })
    })

    this.$store.getters.getSections.sections[3].idPackage === '' ||
    this.$store.getters.getSections.sections[3].idPackage === undefined ||
    this.$store.getters.getSections.sections[3].idPackage === null
      ? section3.push(false)
      : section3.push(true)

    this.msjBienvenida.id == 1 ? section4.push(false) : section4.push(true)
    this.msjBienvenida.id == 2 ? section5.push(false) : section5.push(true)

    title = titleOnboarding.every((element) => element == false)
    infoPersonal = section1.every((element) => element == false)
    docPersonales = section2.every((element) => element == false)
    eForms = section3.every((element) => element == false)
    institucional = section4.every((element) => element == false)
    video = section5.every((element) => element == false)

    if (title) {
      // console.log("Falta el nombre del onboarding");
      return 'err_title'
    } else if (infoPersonal) {
      // console.log("Faltan valores en infoPersonal");
      return 'err_infoPersonal'
    } else if (docPersonales) {
      // console.log("Faltan valores en docPersonales");
      return 'err_docPersonales'
    } else if (eForms) {
      // console.log("Faltan elegir un template");
      return 'err_eF'
    } else if (institucional) {
      if (
        this.institutionalImage.status == 'queued' ||
        (this.institutionalImage.status == undefined &&
          this.msjBienvenida.data.imagen_publica !== '' &&
          this.msjBienvenida.data.imagen_publica != null)
      ) {
        return true
      } else {
        return 'err_img'
      }
    } else if (video) {
      if (this.msjBienvenida.urlVideo == '') {
        return 'err_video'
      } else {
        return true
      }
    } else {
      return true
    }
  }
  checkalldata(nameprop, nameall) {
    let toChange = true
    if (!this[nameall]) {
      toChange = false
    }
    this[nameall] = toChange
    _.each(this.$store.getters.getSections.sections[1].levels, (level: any) => {
      _.each(level.fields, (field: any) => {
        field[nameprop] = toChange
        if (nameall === 'allmandatory' && toChange === true) {
          this['alldata'] = true
          this.setApply(field)
        }
        if (nameall === 'alldata' && toChange === false) {
          this['allmandatory'] = false
          this.setMandatory(field)
        }
      })
    })
    this.validate()
  }
  async save() {
    var ComponentClass = Vue.extend(Alert)
    var typeError = this.validate()
    if (typeError != true) {
      var instance = new ComponentClass({
        propsData: {
          role: 'danger',
          title: 'Error',
          message: this.$t('message.' + typeError)
        }
      }).$mount()
      this.$refs.alert.appendChild(instance.$el)
    } else {
      this.btnSave = true
      if (this.msjBienvenida.id == 1) {
        var tmp = this.msjBienvenida.urlLink
      }
      if (this.msjBienvenida.id == 2) {
        var tmp = this.msjBienvenida.urlVideo
      }

      if (this.selectedDestinationFolder.carpeta_id != '') {
        this.selectedDestinationFolder = _.findWhere(this.foldersAvailable, {
          carpeta_id: this.selectedDestinationFolder.carpeta_id
        })

        // let sections = { sections: { ...this.$store.getters.getSections.sections }};
        //sections[1].folder = this.selectedDestinationFolder;
        this.btnSave = true

        if (this.msjBienvenida.data.mensaje != undefined) {
          this.msjBienvenida.data.mensaje.replace(/\s+/g, ' ')
        }
        await this.ob
          .save(
            this.obname,
            this.$store.getters.getSections,
            this.msjBienvenida.data.mensaje,
            this.msjBienvenida.id,
            tmp,
            this.selectedDestinationFolder.carpeta_id
          )

          .then(
            async (response) => {
              if (response.status == 200) {
                this.btnSave = false
                if (response.data.id && this.institutionalImage) {
                  this.btnSave = true
                  await this.ob
                    .postWelcomeImage(response.data.id, this.institutionalImage)
                    .then(async (res: any) => {
                      if (res.status == 201) {
                        this.btnSave = false
                        this.$store.dispatch('setDropzoneImg', {
                          dropzoneImg: true
                        })

                        swal({
                          position: 'center',
                          type: 'success',
                          title: this.$t(
                            'message.action_save_template_text'
                          ).toString(),
                          showConfirmButton: false,
                          timer: 3000
                        })
                      }
                    })
                    .catch((error: any) => {})
                } else {
                  swal({
                    position: 'center',
                    type: 'success',
                    title: this.$t(
                      'message.action_save_template_text'
                    ).toString(),
                    showConfirmButton: false,
                    timer: 3000
                  })
                }
                this.btnSave = false
              }
              this.$router.push({
                name: 'oblist',
                params: { id: response.id }
              })
            },
            (error) => {
              var instance = new ComponentClass({
                propsData: {
                  role: 'danger',
                  title: 'Error',
                  message: this.$t('message.error_' + error.response.data.code)
                }
              }).$mount()
              this.$refs.alert.appendChild(instance.$el)
              this.btnSave = false
            }
          )
      } else {
        this.errorMessage(
          this.$t('message.ob_destination_folder_warning').toString()
        )
        return
      }
    }
  }
  errorMessage(msg) {
    var ComponentClass = Vue.extend(Alert)
    var instance = new ComponentClass({
      propsData: { role: 'danger', title: 'Error', message: msg }
    }).$mount()
    this.$refs.alert.appendChild(instance.$el)
    this.btnSave = false
  }
  edit() {
    var ComponentClass = Vue.extend(Alert)
    var typeError = this.validate()
    if (typeError != true) {
      var instance = new ComponentClass({
        propsData: {
          role: 'danger',
          title: 'Error',
          message: this.$t('message.' + typeError)
        }
      }).$mount()
      this.$refs.alert.appendChild(instance.$el)
    } else {
      if (this.msjBienvenida.id == 1) {
        var tmp = this.msjBienvenida.urlLink
      }
      if (this.msjBienvenida.id == 2) {
        var tmp = this.msjBienvenida.urlVideo
      }
      this.ob
        .editTemplate(
          this.$route.params.id,
          this.obname,
          this.$store.getters.getSections,
          this.msjBienvenida.data.mensaje.replace(/\s+/g, ' '),
          this.msjBienvenida.id,
          tmp
        )
        .then((res: any) => {
          if (res.status == 200) {
            var instance = new ComponentClass({
              propsData: {
                role: 'success',
                title: 'Correcto',
                message: this.$t('message.msj_success_edit')
              }
            }).$mount()

            if (this.$route.params.id && this.institutionalImage) {
              this.ob
                .postWelcomeImage(
                  this.$route.params.id,
                  this.institutionalImage
                )
                .then((res: any) => {
                  if (res.status == 201) {
                    this.$store.dispatch('setDropzoneImg', {
                      dropzoneImg: true
                    })
                  }
                })
                .catch((error: any) => {})
            }
            this.$refs.alert.appendChild(instance.$el)
          }
        })
        .catch((error: any) => {
          var instance = new ComponentClass({
            propsData: {
              role: 'danger',
              title: 'Error',
              message: this.$t('message.error_' + error.response.data.code)
            }
          }).$mount()
          this.$refs.alert.appendChild(instance.$el)
        })
    }
  }
  welcomeMsj() {
    this.ob
      .getWelcome()
      .then((res: any) => {
        if (res.status == 200) {
          this.msjBienvenida.combo = res.data
        }
      })
      .catch((error: any) => {
        // var instance = new ComponentClass({propsData: { role: 'danger', title: 'Error', message: this.$t('message.error_'+error.response.data.code) }}).$mount();
        // this.$refs.alert.appendChild(instance.$el);
      })
  }
  beforeComplete(file) {
    this.institutionalImage = file
    if (file.previewElement) {
      return file.previewElement.classList.add('dz-complete')
    }
  }
  afterComplete(file) {
    this.institutionalImage = file
  }
  removeFile() {
    this.institutionalImage = ''
  }
  RemoveImg() {
    const that = this
    const header_logout: any = this.$t('message.header_logout')
    const yes_logout_text: any = this.$t('message.yes_logout_text')
    const not_logout_text: any = this.$t('message.not_logout_text')
    const confirm_delete_img_text: any = this.$t(
      'message.confirm_delete_img_text'
    )
    swal({
      title: header_logout,
      text: confirm_delete_img_text,
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonColor: '#88A09E',
      confirmButtonColor: '#54CAA6',
      cancelButtonText: not_logout_text,
      confirmButtonText: yes_logout_text
    }).then((result) => {
      if (result.value) {
        that.ob
          .deleteWelcomeImage(that.$route.params.id)
          .then((res: any) => {
            that.msjBienvenida.data.imagen_publica = null
          })
          .catch((error: any) => {})
      }
    })
  }
  countdown() {
    this.msjBienvenida.remainingCount =
      this.msjBienvenida.maxCount - this.msjBienvenida.data.mensaje.length
  }
  setApply(field) {
    if (field.mandatory && !field.use) field.use = true
  }
  setMandatory(field) {
    if (!field.use && field.mandatory) field.mandatory = false
  }
}
